<template>
  <button
    :class="['hamburger-btn', className]"
    @click="handleClick"
    type="button"
    aria-label="Toggle menu"
  >
    <svg 
      class="hamburger-icon" 
      :class="{ 'is-open': isOpen }"
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24"
    >
      <path
        v-if="!isOpen"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 6h16M4 12h16M4 18h16"
      />
      <path
        v-else
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
interface Props {
  isOpen?: boolean
  className?: string
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
  className: ''
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const handleClick = (event: MouseEvent) => {
  event.stopPropagation()
  emit('click', event)
}
</script>

<style scoped>
.hamburger-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  transition: opacity 0.2s ease;
}

.hamburger-btn:hover {
  opacity: 0.7;
}

.hamburger-btn:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
  border-radius: 4px;
}

.hamburger-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #04406E;
  transition: transform 0.2s ease;
}

.hamburger-icon.is-open {
  transform: rotate(90deg);
}
</style>
